<template>
    <div>
        <div style="background: #FAFAFA; height: 100%;">
            <div class="container">
                <h3 class="bills-text" @click="back()"><span class="fa fa-chevron-left"></span>Transaction History</h3>
                <div class="filter-holder">
                    <div class="filter-wrap">
                        <select class="form-control col-md-4" name="category" id="category" v-model="category" @change="handleSelectionCategory">
                            <option value="" selected>All category</option>
                            <option value="airtime">Airtime</option>
                            <option value="data">Data</option>
                            <option value="electricity">Electricity</option>
                            <option value="tv">Tv or Cable</option>
                        </select>

                        <select name="" id="subject" class="form-control col-md-4" v-model="status">
                            <!-- <option value="" selected disabled>Status</option> -->
                            <option value="" selected>All status</option>
                            <option value="1">Successful</option>
                            <!-- <option value="pending">Pending</option> -->
                            <option value="0">Failed</option>
                            <!-- <option value="reversed">Reversed</option> -->
                        </select>
                    </div>
                </div>
                <div v-if="loading">
                    <PageLoader></PageLoader>
                </div>
                <div v-else>
                    <div class="history-holder" v-if="transactionsHitory.length > 0">
                        <div class="history-item" v-for="(item, index) in transactionsHitory" :key="index">
                            <h6 v-if="item.data">{{JSON.parse(item.data.vendTime | moment2)}}</h6>
                            <h6 v-else>{{item.updated_at | moment2}}</h6>
                            <div class="d-flex justify-content-between purchase">
                                <div class="d-flex justify-content-between align-items-start">
                                    <img class="w-100 mr-3" 
                                    :src="item.category == 'airtime' ? require('../../assets/billpayment/airtime-call.svg') : 
                                    item.category == 'data' ? require('../../assets/billpayment/data-internent.svg') : 
                                    item.category == 'electricity' ? require('../../assets/billpayment/electricity-bulb.svg') :
                                    require('../../assets/billpayment/cable-tv.svg')
                                    " 
                                    alt=""
                                    >

                                    </img>
                                    <div>
                                        <h4>{{item.category}} </h4>
                                        <h5 v-if="item.data">{{JSON.parse(item.data.vendTime | moment3)}}</h5>
                                        <h5 v-else>{{item.updated_at | moment3}}</h5>
                                    </div>
                                </div>
                                <div class="">
                                    <h4> ₦{{ Number(item.amount).toLocaleString() }}</h4>
                                    <p v-if="item.status == '1'" class="success">Successful</p>
                                    <p v-if="item.status == '0'" class="failed">Failed</p>
                                </div>
                            </div>
                            <!-- <div class="d-flex justify-content-between purchase">
                                <div class="d-flex justify-content-between align-items-center">
                                    <img class="w-100 mr-3" src="../../assets/billpayment/data-internent.svg" alt="data">
                                    <div>
                                        <h4>Data</h4>
                                        <h5>02:18 AM</h5>
                                    </div>
                                </div>
                                <div class="">
                                    <h4>₦3,000.00</h4>
                                    <p class="success">Successful</p>
                                </div>
                            </div> -->
                        </div>
                        <Pagination
                        v-if="transactionsHitory"
                        @pageData="dataFromChild($event)"
                    ></Pagination>
                    </div>
                </div> 
            </div>
        </div>
    </div>
</template>

<script>
import Pagination from "../../components/Pagination.vue";
import { Service } from "../../store/service";
import PageLoader from "../../components/PageLoader.vue";
import moment from "moment";
const Api = new Service();
    export default {
        name: "History",
        components: {
            Pagination,
            PageLoader,
        },
        data() {
            return {
                JSON: JSON,
                loading: false,
                activeIndex: null,
                transactionsHitory: [],
                parsedData: [],
                page: 1,
                limit: 10,
                totalcount: "",
                thePageNum: [],
                parsedArray: [],
                status: "",
                category: "",
            }
        },
        watch: {
            category(newVal) {
                if(newVal) {
                    this.fetchBillHistory();
                }
            },
            status(newVal) {
                if(newVal) {
                    this.fetchBillHistory();
                }
            }
        },
        computed: {
            
        },
        mounted() {
            this.fetchBillHistory();
            // this.dataFromChild('');
        },
        methods: {
            routeTo(route) {
                this.$router.push({
                path: route
                })
                .catch(() => {});
            },
            back() {
                this.$router.back();
            },
            handleSelectionCategory() {

            },
            togglePanel(index) {
                if(this.activeIndex != index) {
                    this.activeIndex = index;
                }
                else {
                this.activeIndex = null;
                }
            },

            async fetchBillHistory() {
                this.loading = true;
                try {
                    await Api.getRequest(`billshistory?page=${this.page}&perpage=${this.limit}&status=${this.status}&category=${this.category}`)
                    .then(res => {
                        this.loading = false;
                        // console.log("Bills history", res)
                        
                        if (res.status == 200) {
                            // this.dataFromChild(res)
                            this.pageUrlGlobal();
                            this.transactionsHitory = res.data.transactions;
                            this.totalcount = res.data.totalpages;
                            this.newTransaction = res.data.transactions;
                            // this.pageUrlGlobal();
                            // this.limit = res.data.perpage;
                            // this.page = res.data.page;
                            
                            // this.parsedArray = res.data.transactions.map(item => ({...item,
                            //     data: JSON.parse(item.dump)
                            // }));
                            // this.parsedData = this.parsedArray;
                           
                            // this.dataFromChild(res)
                            
                           
                        }
                        else {
                            return this.$store.commit("setApiFailed", "Error occured");
                        }
                    })
                    .catch(err => {
                        console.log("ERROR", err);
                        this.loading = false;
                    });
                } finally {
                // console.log("Closed connection");
                }
            },
            dataFromChild(data) {
                // this.loading = true;
                this.page = Number(data.data.page);
                this.limit = Number(data.data.perpage);
                // this.transactionsHitory = data.data.transactions;
                console.log("check tranhis", data)
                // this.transactionsHitory =  this.newTransaction;
                // this.parsedArray = data.data.transactions;
            },
            pageUrlGlobal() {
                Api.pushPageURL(`billshistory?page=${this.page}&perpage=${this.limit}&status=${this.status}&category=${this.category}`);
            },
        },
        filters: {
            moment: function(date) {
                return moment(date).format("MMMM Do YYYY, h:mm:ss a");
            },
            moment2: function(date) {
                return moment(date).format("MMMM Do YYYY");
            },
            moment3: function(date) {
                return moment(date).format("hh:mm A");
            }
        }
    }
    
</script>

<style scoped lang="scss">

.bills-text {
    font-family: Lato;
    font-weight: 600;
    font-size: 20px;
    line-height: 60px;
    text-align: left;
    color: #1A1A1A;
    // margin-top: 40px;
    span {
        font-size: 18px;
        margin-right: 20px;
        cursor: pointer;
    }
}

.filter-wrap {
    display: flex;
    justify-content: center;
    gap: 20px;
    background: #ffffff;
    padding: 20px 15px;
    border-radius: 8px;
}

select {
    box-shadow: none !important;
    outline: 0 !important;
    height: 48px;
    font-family: Lato;
    font-weight: 500;
    color: #555555;
    font-size: 16px;
}

.history-holder {
    // background:  #ffffff;
    // border-radius: 8px;
    // padding: 30px 15px;
    // margin-top: 40px;
}
.history-item {
    margin-top: 40px;
    background:  #ffffff;
    border-radius: 8px;
    padding: 30px 15px;
    margin-top: 30px;
    h6 {
        font-family: Lato;
        font-weight: 400;
        font-style: Regular;
        font-size: 16px;
        line-height: 100%;
        color: #555555A6;
        text-align: left;
        margin-bottom: 30px;

    }
    h4 {
        font-family: Lato;
        font-weight: 500;
        font-size: 16px;
        text-align: left;
        // line-height: 100%;
        color: #1A1A1A;
        white-space: nowrap;
        text-transform: capitalize;

    }
    h5 {
        font-family: Lato;
        font-weight: 400;
        font-size: 14px;
        // line-height: 100%;
        text-align: left;
        color: #555555A6;
        white-space: nowrap;

    }
}

.success {
    font-family: Lato;
    font-weight: 400;
    font-size: 14px;
    color: #4688F4;
    background: #F8F9FA;
    border-radius: 50px;
    margin-bottom: 0;
}
.failed {
    font-family: Lato;
    font-weight: 400;
    font-size: 14px;
    color: #DC3545;
    background: #fceeef;
    border-radius: 50px;
    margin-bottom: 0;
}

.purchase:not(:last-child) {
    margin-bottom: 40px;
}

@media only screen and (max-width: 599px) {
    .success, .failed {
        font-size: 12px;
    }
}
</style>
